import { Formik, ErrorMessage } from 'formik';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateAddBank } from '../../utils/validateValues';
import { addBankValues } from '../../utils/initialValues';

const AddBank = () => {
  const history = useNavigate();
  let message;
  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);
  const initialValues = addBankValues();
  const validationSchema = validateAddBank();

  const handleFormSubmit = (values) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/marketers/add-bank`, {
        bankName: values.bankName,
        accountName: values.accountName,
        accountNumber: values.accountNumber,
        accountType: values.accountType,
      })
      .then((res) => {
        message = res.data.message;
        if (res.status === 200) {
          successNotification(message);
          setTimeout(() => history('/banks'), 2000);
        } else {
          errorNotification(message);
        }
      })
      .catch((err) => {
        console.log(err);
        errorNotification(err);
      });
  };

  return (
    <div className="profileForm">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="bankName">Bank Name</label>
              <input
                type="text"
                id="bankName"
                name="bankName"
                value={values.bankName}
                error={!!touched.bankName && !!errors.bankName}
                helpertext={touched.bankName && errors.bankName}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter your bank name"
              />
              <ErrorMessage name="bankName" component="span" className="error" />
            </div>

            <div>
              <label htmlFor="accountName">Account Name</label>
              <input
                type="text"
                id="accountName"
                name="accountName"
                value={values.accountName}
                error={!!touched.accountName && !!errors.accountName}
                helpertext={touched.accountName && errors.accountName}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Provide the account name"
              />
              <ErrorMessage name="accountName" component="span" className="error" />
            </div>

            <div>
              <label htmlFor="accountNumber">Account Number</label>
              <input
                type="number"
                id="accountNumber"
                name="accountNumber"
                value={values.accountNumber}
                error={!!touched.accountNumber && !!errors.accountNumber}
                helpertext={touched.accountNumber && errors.accountNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter the account number"
              />
              <ErrorMessage name="accountNumber" component="span" className="error" />
            </div>

            <div>
              <label htmlFor="accountType">Account Type</label>
              <select
                name="accountType"
                id="accountType"
                value={values.accountType}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option value="">Select account type</option>
                <option value="Savings">Savings</option>
                <option value="Current">Current</option>
                <option value="Checking">Checking</option>
                <option value="Others">Others</option>
              </select>
              <ErrorMessage name="accountType" component="span" className="error" />
            </div>

            <button type="submit">Add Bank Details</button>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default AddBank;
